import type { Wedding } from '../../types';
import { getStoredPublicConfigFromWedding } from '../invitation/defaults';

/**
 * Řádek z `weddings` má JSON ve sloupci `public_config`; TypeScript očekává `publicConfig`.
 * Bez sjednocení se po `refreshWedding()` ztratí uložená data v UI.
 */
export function normalizeWeddingFromSupabase(row: Record<string, unknown>): Wedding {
  const w = row as unknown as Wedding;
  const stored = getStoredPublicConfigFromWedding(w);
  const b = (k: string, d: boolean) =>
    typeof stored[k] === 'boolean' ? (stored[k] as boolean) : d;
  return {
    ...w,
    publicConfig: {
      showSchedule: typeof stored.showSchedule === 'boolean' ? stored.showSchedule : true,
      showFaq: typeof stored.showFaq === 'boolean' ? stored.showFaq : true,
      welcomeMessage: (stored.welcomeMessage as string | undefined) ?? '',
      brideName: stored.brideName as string | undefined,
      groomName: stored.groomName as string | undefined,
      bridePhotoUrl: stored.bridePhotoUrl as string | undefined,
      groomPhotoUrl: stored.groomPhotoUrl as string | undefined,
      ceremonyTime: stored.ceremonyTime as string | undefined,
      ceremonyVenue: stored.ceremonyVenue as string | undefined,
      fullAddress: stored.fullAddress as string | undefined,
      mapsUrl: stored.mapsUrl as string | undefined,
      dressCode: stored.dressCode as string | undefined,
      heroImageUrl: stored.heroImageUrl as string | undefined,
      storyText: stored.storyText as string | undefined,
      showCatering: b('showCatering', false),
      cateringIntro: stored.cateringIntro as string | undefined,
      cateringShowMain: b('cateringShowMain', false),
      cateringMainText: stored.cateringMainText as string | undefined,
      cateringShowWarmBuffet: b('cateringShowWarmBuffet', false),
      cateringWarmBuffetText: stored.cateringWarmBuffetText as string | undefined,
      cateringShowColdBuffet: b('cateringShowColdBuffet', false),
      cateringColdBuffetText: stored.cateringColdBuffetText as string | undefined,
      cateringShowSweetBar: b('cateringShowSweetBar', false),
      cateringSweetBarText: stored.cateringSweetBarText as string | undefined,
      cateringShowDrinks: b('cateringShowDrinks', false),
      cateringDrinksText: stored.cateringDrinksText as string | undefined,
      cateringMainPhotoUrl: stored.cateringMainPhotoUrl as string | undefined,
      cateringWarmPhotoUrl: stored.cateringWarmPhotoUrl as string | undefined,
      cateringColdPhotoUrl: stored.cateringColdPhotoUrl as string | undefined,
      cateringSweetPhotoUrl: stored.cateringSweetPhotoUrl as string | undefined,
      cateringDrinksPhotoUrl: stored.cateringDrinksPhotoUrl as string | undefined,
      showMusic: b('showMusic', false),
      musicIntro: stored.musicIntro as string | undefined,
      musicLiveDj: b('musicLiveDj', false),
      musicFromSpeakers: b('musicFromSpeakers', false),
      musicSpotifyUrl: stored.musicSpotifyUrl as string | undefined,
      musicPlaylistCta: stored.musicPlaylistCta as string | undefined,
      showEntertainment: b('showEntertainment', false),
      entertainmentIntro: stored.entertainmentIntro as string | undefined,
      showAccommodationInfo: b('showAccommodationInfo', false),
      accommodationInfo: stored.accommodationInfo as string | undefined,
      accommodationMapsUrl: stored.accommodationMapsUrl as string | undefined,
    },
  };
}
